angular.module('qkr').filter('punchCardExpiryDate', ['$filter', function($filter) {
    return function(input) {
        if (input == 'undefined' || input == null) {
            return '';
        } else {
            const dateInput = new Date(input);
            if (dateInput <= new Date()) {
                return 'N/A';
            }
            if (dateInput.getFullYear() >= 2999) {
                return '∞';
            }
            return $filter('date')(dateInput, 'mediumDate');
        }
    };
}]);




// WEBPACK FOOTER //
// ./src/filters/punch_card_expiry_date.js